import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';
// Component
import { connect } from 'react-redux';
import { LIGHTMODE_LOADER_COMMON_COLOR, DARKMODE_LOADER_COMMON_COLOR } from '../../../constants';
import CustomCircleLoader from './CustomCircleLoader';
import s from './Loader.css';

class CircleLoader extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired
    };

    static defaultProps = {
        show: false
    };

    render() {
        const { show, selectedTheme } = this.props;

        if (!show) {
            return <div />;
        }

        return (
            <div className={cx(s.textCenter)}>
                <CustomCircleLoader
                    singleColor={selectedTheme == 'light' ? LIGHTMODE_LOADER_COMMON_COLOR : DARKMODE_LOADER_COMMON_COLOR}
                    size={30}
                    borderSize={3} />
            </div>
        );
    }
}

const mapState = state => ({
    selectedTheme: state.currency.theme
});

export default connect(mapState)(CircleLoader);
